import { join } from 'juriquery'

import { Query } from '../types'

export const POLICIES_ROOT_ROUTE = '/policies'

export const POLICIES_ROUTE = `${POLICIES_ROOT_ROUTE}/clinics/:clinicId`
export const POLICIES_ASSIGNMENTS_ROUTE = 'assignments'
export const POLICIES_UPLOAD_ROUTE = 'upload'
export const POLICIES_APPROVERS_ROUTE = 'approvers'
export const POLICIES_APPROVAL_ROUTE = 'approval'
export const POLICIES_ASSIGN_ROUTE = 'assign'
export const POLICIES_OVERVIEW_EXTERNAL_ROUTE = 'overview/external'
export const POLICIES_SUGGESTIONS_ROUTE = 'suggestions'

export const POLICIES_POLICY_ROUTE = 'policy/:policyId'
export const POLICIES_POLICY_ASSIGN_ROUTE = 'policy/:policyId/assign'
export const POLICIES_POLICY_HISTORY_ROUTE = 'policy/:policyId/history'
export const POLICIES_POLICY_EDITOR_ROUTE = 'policy/:policyId/editor'

const getRouteWithInjectedPolicyId = (route: string, policyId: number) =>
  route.replace(':policyId', `${policyId}`)

export const getPoliciesRootRoute = (clinicId: number) =>
  POLICIES_ROUTE.replace(':clinicId', `${clinicId}`)

export const getPoliciesRoute = (clinicId: number, query?: Query | string) =>
  join(getPoliciesRootRoute(clinicId), query)

export const getPoliciesPolicyRoute = (clinicId: number, policyId: number) =>
  `${getPoliciesRootRoute(clinicId)}/${getRouteWithInjectedPolicyId(
    POLICIES_POLICY_ROUTE,
    policyId,
  )}`

export const getPoliciesPolicyAssignRoute = (
  clinicId: number,
  policyId: number,
) =>
  `${getPoliciesRootRoute(clinicId)}/${getRouteWithInjectedPolicyId(
    POLICIES_POLICY_ASSIGN_ROUTE,
    policyId,
  )}`

export const getPoliciesPolicyEditorRoute = (
  clinicId: number,
  policyId: number,
  query?: Query | string,
) => join(`${getPoliciesPolicyRoute(clinicId, policyId)}/editor`, query)

export const getPoliciesPolicyHistoryRoute = (
  clinicId: number,
  policyId: number,
  query?: Query | string,
) => join(`${getPoliciesPolicyRoute(clinicId, policyId)}/history`, query)

export const getPoliciesAssignmentsRoute = (clinicId: number) =>
  `${getPoliciesRootRoute(clinicId)}/${POLICIES_ASSIGNMENTS_ROUTE}`

export const getPoliciesUploadRoute = (clinicId: number) =>
  `${getPoliciesRootRoute(clinicId)}/${POLICIES_UPLOAD_ROUTE}`

export const getPoliciesApproversRoute = (clinicId: number) =>
  `${getPoliciesRootRoute(clinicId)}/${POLICIES_APPROVERS_ROUTE}`

export const getPoliciesApprovalRoute = (clinicId: number) =>
  `${getPoliciesRootRoute(clinicId)}/${POLICIES_APPROVAL_ROUTE}`

export const getPoliciesOverviewExternalRoute = (
  clinicId: number,
  token?: string,
) =>
  join(
    `${getPoliciesRootRoute(clinicId)}/${POLICIES_OVERVIEW_EXTERNAL_ROUTE}`,
    { token },
  )

export const getPoliciesSuggestionsRoute = (clinicId: number) =>
  `${getPoliciesRootRoute(clinicId)}/${POLICIES_SUGGESTIONS_ROUTE}`

export const getPoliciesAssignRoute = (clinicId: number) =>
  `${getPoliciesRootRoute(clinicId)}/${POLICIES_ASSIGN_ROUTE}`
